import { getStack } from '@nuskin/contentstack-lib'
import { observable } from 'mobx'
import { APPConfig } from 'config/appConfig'

export class NextGenTranslationContent {
  @observable nextGenTranslationContentValue = {}
  @observable nextGenTranslationLoadedContentTypes = []

  constructor({
    getStackClient = getStack,
    getAppConfig = () => APPConfig?.getAppConfig(),
  } = {}) {
    this.getStackClient = getStackClient
    this.getAppConfig = getAppConfig
  }

  transformKey = (key = '') => {
    if (typeof key !== 'string') return ''
    return key.replace(/[_-]+([a-zA-Z])/g, (_, c) => c.toUpperCase())
  }

  transformTranslateKeys = (
    translationObject,
    prefix = '',
    transformedContent = {}
  ) => {
    for (const key in translationObject) {
      const transformedContentKey = this.transformKey(key)
      const value = translationObject[key]
      const newKey = prefix
        ? `${prefix}.${transformedContentKey}`
        : transformedContentKey

      if (
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value)
      ) {
        this.transformTranslateKeys(value, newKey, transformedContent)
      } else {
        transformedContent[newKey] = value
      }
    }
    return transformedContent
  }

  fetchNextGenTranslationContent = async (translationObj = {}) => {
    const {
      locale = '',
      contentTypeId = 'nextgen_translation_content',
      contentType = '',
    } = translationObj
    const { CS_ENV = '' } = this.getAppConfig() || {}
    const localeKey = locale || 'en-US'
    const [language = '', country = ''] = localeKey?.includes('_')
      ? localeKey.split('_')
      : localeKey.split('-')
    const env = CS_ENV?.replace('public-', '') || 'public-test'

    if (this.nextGenTranslationLoadedContentTypes.includes(contentType)) {
      return this.nextGenTranslationContentValue
    }

    try {
      const Stack = this.getStackClient(env)
      const options = {
        contentTypeUIDs: [contentTypeId],
        country: country?.toUpperCase() ?? 'US',
        language: language?.toLowerCase() ?? 'en',
        camelcase: true,
        mergeWithFallback: false,
      }
      const [data = {}] = await Stack.getSingletonEntries(options)
      if (!data || !Object.keys(data).length) {
        return this.nextGenTranslationContentValue
      }

      this.nextGenTranslationLoadedContentTypes.push(contentType)
      const translationKeyValue = this.transformTranslateKeys(data) || {}
      this.nextGenTranslationContentValue = {
        ...this.nextGenTranslationContentValue,
        ...translationKeyValue,
      }
      return this.nextGenTranslationContentValue
    } catch (error) {
      console.log('Error fetching next gen translation content:', error)
      return this.nextGenTranslationContentValue
    }
  }
}

const nextGenTranslationContent = new NextGenTranslationContent()

export { nextGenTranslationContent }
export default nextGenTranslationContent
